<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h3 class="font-weight-bold">นำเข้าพัสดุ Line Booking</h3>
            </div>
        </div>
        <form @submit.prevent="validateBookingLine" class="py-2">
            <div class="row">
                <div :class="[calScreenFull ? 'col-lg-4' : 'col-lg-6']">
                    <div class="form-group">
                        <label>
                            หมายเลข Booking ID
                        </label>
                        <input
                            type="text"
                            placeholder="สแกน QR Code หรือ พิมพ์ Booking ID"
                            class="form-control"
                            :class="{ 'is-invalid': submitForm && $v.booking.bookingNo.$error }"
                            v-model="booking.bookingNo"
                        />
                        <label
                            v-if="submitForm && !$v.booking.bookingNo.required"
                            class="invalid-feedback"
                        >กรุณากรอกหมายเลข Booking ID</label>
                    </div>
                </div>
                <div :class="[
                    'pt-2 d-flex',
                    calScreenFull ? 'col-lg-8' : 'col-lg-6',
                    submitForm && $v.booking.bookingNo.$error ? 'align-items-center' : 'align-items-end'
                ]">
                    <div class="form-group">
                        <b-button type="submit" variant="primary" class="px-5">
                            <i class="fas fa-circle-notch fa-spin" v-if="booking.isLoading"></i>
                            ค้นหา
                        </b-button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-lg-6">
                <label>
                    ข้อมูลผู้ส่ง
                </label>
                <div class="row py-2">
                    <div class="col-sm-3">
                        <label class="text-muted">ชื่อผู้ส่ง</label>
                    </div>
                    <div class="col-sm-9">
                        {{ sender.name }}
                    </div>
                </div>
                <div class="row py-2">
                    <div class="col-sm-3">
                        <label class="text-muted">เบอร์โทร</label>
                    </div>
                    <div class="col-sm-9">
                        {{ sender.tel }}
                    </div>
                </div>
                <div class="row py-2">
                    <div class="col-sm-3">
                        <label class="text-muted">ที่อยู่ผู้ส่ง</label>
                    </div>
                    <div class="col-sm-9">
                        {{ [
                                sender.address, 
                                sender.state, 
                                sender.district, 
                                sender.province, 
                                sender.postcode
                            ].join(' ')
                        }}
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <label>
                    รายละเอียด Booking ID
                </label>
                <div class="row py-2">
                    <div class="col-sm-4">
                        <label class="text-muted">หมายเลข Booking ID</label>
                    </div>
                    <div class="col-sm-8">
                        {{ this.booking.createdAt ? this.booking.bookingNo : '-' }}
                    </div>
                </div>
                <div class="row py-2">
                    <div class="col-sm-4">
                        <label class="text-muted">วันที่ทำรายการ</label>
                    </div>
                    <div class="col-sm-8">
                        {{ this.booking.createdAt }}
                    </div>
                </div>
                <div class="row py-2">
                    <div class="col-sm-4">
                        <label class="text-muted">จำนวนพัสดุ</label>
                    </div>
                    <div class="col-sm-8">
                        {{ this.booking.totalShipment }} รายการ
                    </div>
                </div>
                <div class="row py-2">
                    <div class="col-sm-4">
                        <label class="text-muted">รูปแบบการจัดส่ง</label>
                    </div>
                    <div class="col-sm-8">
                        {{ this.booking.noteToShop }}
                    </div>
                </div>
                <div class="row py-2">
                    <div class="col-sm-4">
                        <label class="text-muted">รายละเอียดเพิ่มเติม</label>
                    </div>
                    <div class="col-sm-8">
                        -
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
  required,
} from "vuelidate/lib/validators"
import { getLineBookingByBookingNo } from "@/axios/booking"

export default {
    props:{
        showCart: {
            type: String,
            default: "", 
        },
        booking: {
            type: Object,
            default: () => {}, 
        },
        sender: {
            type: Object,
            default: () => {}, 
        },
        dropoffLine: {
            type: Object,
            default: () => {}, 
        }
    },
    data: () => ({
        submitForm: false,
    }),
    validations() {
        return {
            booking: {
                bookingNo: { required },
            }
        };
    },
    methods:{
        validateBookingLine(){
            this.submitForm = true;
            this.$v.booking.$touch();
            if (this.$v.booking.$invalid) {
                return false
            }

            this.scanBookingLine()
        },
        scanBookingLine(){
            this.booking.isLoading = true

            getLineBookingByBookingNo(this.booking.bookingNo).then( res => {
                this.booking.createdAt = res.created_at
                this.booking.totalShipment = res.total_shipment
                this.booking.bookingItems = res.draft_order_item
                this.booking.noteToShop = res.note_to_shop
                this.dropoffLine.bookingId = res.booking_id
                this.booking.isLoading = false
            }).catch( error => {
                this.$emit(
                    'openModalAlert',
                    '<i class="fas fa-exclamation-triangle text-yellow fa-5x"></i>',
                    error
                )
                this.booking.isLoading = false
            })
        }
    },
    computed:{
        calScreenFull(){
            return this.showCart === '';
        },
    }
}
</script>